import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, makeStyles } from '@material-ui/core';
import RecentActorsIcon from '@material-ui/icons/RecentActors';

import { ValidatedTextField } from 'components';
import { useFormikContext } from 'formik';

import { UserSegmentValues } from '../../types';

interface IProps {
  activeIcon: boolean;
  mode: 'create' | 'edit';
  working: boolean;
}

const useStyles = makeStyles(theme => ({
  saveButton: {
    marginRight: theme.spacing(1),
  },
}));

const SegmentTitle: FC<IProps> = ({ activeIcon, mode, working }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { values, touched } = useFormikContext<UserSegmentValues>();

  const isEditing = mode === 'edit';
  const i18nKey = isEditing ? 'common:save' : 'common:add';
  let endAdornment = null;

  if (touched.title && !!values.title) {
    endAdornment = (
      <Button
        disabled={working}
        type="submit"
        variant="contained"
        color="primary"
        className={classes.saveButton}>
        {t(i18nKey)}
      </Button>
    );
  }

  return (
    <Grid container alignItems="center" spacing={2}>
      {isEditing && (
        <Grid item>
          <RecentActorsIcon color={activeIcon ? 'primary' : 'disabled'} fontSize="large" />
        </Grid>
      )}
      <Grid item xs={isEditing ? true : 5}>
        <ValidatedTextField
          name="title"
          i18nKey="admin:userSegmentAdd"
          color="primary"
          TextFieldProps={{ margin: 'none', label: null }}
          InputProps={{
            endAdornment,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SegmentTitle;
